import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingScreen from "../../../utils/LoadingScreen";
import "../../whatsapp/WhatsApp.css";
import useWhatsappNumbers from "../../../services/Whatsapp/useWhatsappNumbers";
import useMedia from "../../../services/Whatsapp/useMedia";
import useTemplates from "../../../services/Whatsapp/useTemplates";
import NoIndex from "../../../components/NoIndex";
import * as XLSX from "xlsx";
import useCampaigns from "../../../services/Whatsapp/useCampaigns";
import { GlobalContext } from "../../../Context/GlobalContext";

const NewCampaign = () => {
  const { whatsappNumbers } = useWhatsappNumbers();
  const {
  uploadImage,
  uploadVideo,
  uploadDocument,
  uploadCampaignExcel,
} = useMedia();
  const { templates, fetchVendorTemplates } = useTemplates();
  const { createCampaign } = useCampaigns();

  const { userID } = useContext(GlobalContext);
const navigate = useNavigate();
  const [campaignName, setcampaignName] = useState("");
  const [errorName, setErrorName] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [imageFile, setImageFile] = useState([]);
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [documentPreviewUrl, setDocumentPreviewUrl] = useState("");
  const [documentFile, setDocumentFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [uploadedMediaUrl, setUploadedMediaUrl] = useState("");
  const [templateFormat, setTemplateFormat] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [footerText, setFooterText] = useState("");
  const [buttonText, setButtonText] = useState([]);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const [campaignType, setCampaignType] = useState("instant");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [templateMetaId, setTemplateMetaId] = useState("");
  const [templateCategory, setTemplateCategory] = useState("");
  const [templateLanguage, setTemplateLanguage] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const safeDecode = (text) => {
    if (!text) return "";

    try {
      return atob(text);
    } catch (e) {
      return text;
    }
  };

  const isFormValid = () => {
    if (!campaignName) {
      toast.error("Campaign Name is required");
      return false;
    }

    const finalNumber = SingleWhatsApp || whatsappNumbers?.[0]?.phone_no_id;

    if (!finalNumber) {
      toast.error("WhatsApp number not available");
      return false;
    }

    if (!selectedTemplate) {
      toast.error("Please select Template");
      return false;
    }

    if (!fileUrl) {
      toast.error("Please upload Excel file");
      return false;
    }

    if (campaignType === "schedule" && (!startDate || !startTime)) {
      toast.error("Please select Start Date & Time");
      return false;
    }

    return true;
  };

  const handleTemplateSelect = (e) => {
    const name = e.target.value;
    const temp = templates.find((t) => t.name === name);

    if (!temp) return;
    setSelectedTemplate(temp);
    setTemplateMetaId(temp.id);
    setTemplateCategory(temp.category);
    setTemplateLanguage(temp.language);

    let header = "";
    let body = "";
    let footer = "";
    let buttons = [];
    let format = "";

    temp.components?.forEach((c) => {
      if (c.type === "HEADER") {
        format = (c.format || "").toUpperCase();

        if (format === "TEXT") {
          header = c.text || "";
        }
      }

      if (c.type === "BODY") {
        body = c.text || "";
      }

      if (c.type === "FOOTER") {
        footer = c.text || "";
      }

      if (c.type === "BUTTONS") {
        if (Array.isArray(c.buttons)) {
          buttons = c.buttons.map((b) => b.text);
        }
      }
    });

    setHeaderText(header);
    setBodyText(body);
    setFooterText(footer);
    setButtonText(buttons);
    setTemplateFormat(format);
    setAnimate(false);
    setTimeout(() => setAnimate(true), 100);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile([file]);
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result.split(",")[1];
      const res = await uploadImage(file.name, base64);
      if (res?.status === "0") {
        setUploadedMediaUrl(res.image_url);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setMediaUploadLoading(true);
    const res = await uploadVideo(file);
    if (res?.responseCode === "00") {
      setUploadedMediaUrl(res.data.mediaUrl);
      setVideoUrl(res.data.mediaUrl);
    }
    setMediaUploadLoading(false);
  };

  const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!selectedTemplate) {
    toast.error("Please select template first");
    return;
  }

  try {
    setIsProcessing(true);

    const uploadedHeaders = await readExcelHeaders(file);
    const expectedHeaders = getExpectedExcelHeaders(selectedTemplate);

    console.log("EXPECTED EXCEL HEADERS:", expectedHeaders);
    console.log("UPLOADED EXCEL HEADERS:", uploadedHeaders);

    if (!arraysAreEqual(expectedHeaders, uploadedHeaders)) {
      toast.error(
        `Excel format mismatch. Expected columns: ${expectedHeaders.join(", ")}`
      );
      e.target.value = "";
      return;
    }

    const res = await uploadCampaignExcel(file);

    console.log("Excel Upload Response:", res);

    if (res?.status === "0") {
      setFileUrl(res.file_url);
      toast.success("Excel uploaded successfully");
    } else {
      toast.error(res?.msg || "Upload failed");
    }
  } catch (err) {
    console.error("Excel upload error:", err);
    toast.error(
      typeof err === "string" ? err : "Something went wrong while reading Excel"
    );
  } finally {
    setIsProcessing(false);
  }
};

const handleDocumentUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  if (!allowedTypes.includes(file.type)) {
    toast.error(
      "Please select a valid document file: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX"
    );
    return;
  }

  if (file.size > 16 * 1024 * 1024) {
    toast.error("Document file size must be 16MB or less");
    return;
  }

  try {
    setMediaUploadLoading(true);
    setDocumentFile(file);
    setDocumentPreviewUrl(URL.createObjectURL(file));

    const res = await uploadDocument(file);

    console.log("Document Upload Response:", res);

    if (res?.responseCode === "00") {
      const mediaUrl = res?.data?.mediaUrl || res?.data?.mediaId || "";

      if (!mediaUrl) {
        toast.error("Document uploaded but media URL missing");
        return;
      }

      setUploadedMediaUrl(mediaUrl);
      toast.success("Document uploaded successfully");
    } else {
      toast.error(res?.responseMessage || "Document upload failed");
    }
  } catch (err) {
    console.error("Document upload error:", err);
    toast.error("Something went wrong while uploading document");
  } finally {
    setMediaUploadLoading(false);
  }
};

  const downloadSampleExcel = (template) => {
    if (!template) return;

    const bodyComponent = template.components?.find(
      (comp) => comp.type === "BODY",
    );

    const variableColumn =
      bodyComponent?.text
        ?.match(/\{\{(\d+)\}\}/g)
        ?.map((_, i) => `var${i + 1}`) || [];

    const mediaComponent = template.components?.find(
      (comp) =>
        comp.type === "HEADER" &&
        (comp.format === "VIDEO" || comp.format === "IMAGE"),
    );

    // const isMediaTemplate = !!mediaComponent;

    const headers = ["mobileNumber"];

    headers.push(...variableColumn);

    const sampleData = [];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template Data");

    XLSX.writeFile(wb, `${template.name}_sample.xlsx`);
  };

  const getExpectedExcelHeaders = (template) => {
  if (!template) return ["mobileNumber"];

  const bodyComponent = template.components?.find(
    (comp) => comp.type === "BODY"
  );

  const variableColumn =
    bodyComponent?.text
      ?.match(/\{\{(\d+)\}\}/g)
      ?.map((_, i) => `var${i + 1}`) || [];

  return ["mobileNumber", ...variableColumn];
};

const readExcelHeaders = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject("No file selected");
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const firstRowData = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          range: 0,
        });

        if (!firstRowData.length || !firstRowData[0]?.length) {
          reject("Uploaded file is empty or unreadable");
          return;
        }

        resolve(firstRowData[0]);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const arraysAreEqual = (arr1 = [], arr2 = []) => {
  if (arr1.length !== arr2.length) return false;

  return arr1.every(
    (value, index) =>
      String(value).trim().toLowerCase() ===
      String(arr2[index]).trim().toLowerCase()
  );
};

 const CreateNewCampaign = async () => {
  if (!isFormValid()) return;

  if (
    ["IMAGE", "VIDEO", "DOCUMENT"].includes(templateFormat) &&
    !uploadedMediaUrl
  ) {
    toast.error(`Please upload ${templateFormat.toLowerCase()} header media`);
    return;
  }

  try {
    const payload = {
      userid: userID,
      campaignName: campaignName,
      channel: "Whatsapp",
      phoneNumberId:
        SingleWhatsApp || whatsappNumbers?.[0]?.phone_no_id || "",
      excelUrl: fileUrl,

      template: selectedTemplate?.name,
      template_category: templateCategory,
      templateMetaId: templateMetaId,
      templateFormat: templateFormat,
      language_code: templateLanguage,

      mediaUrl: uploadedMediaUrl || "",
      purpose: "",

      startTime:
        campaignType === "schedule" ? `${startDate} ${startTime}:00` : " :00",

      endTime: " :00",
      interval: "",

      instant: campaignType === "instant" ? "Y" : "N",
    };

    const res = await createCampaign(payload);

    if (res?.responseCode === "00") {
      toast.success("Campaign Created Successfully");

      setTimeout(() => {
        navigate("/WhatsApp/Manage1");
      }, 800);
    } else {
      toast.error(res?.responseMessage || "Failed to create campaign");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  useEffect(() => {
    if (SingleWhatsApp) {
      fetchVendorTemplates(SingleWhatsApp);
    }
  }, [SingleWhatsApp]);

  useEffect(() => {
    fetchVendorTemplates();
  }, []);

  useEffect(() => {
    if (whatsappNumbers?.length > 0 && !SingleWhatsApp) {
      setSingleWhatsApp(whatsappNumbers[0].phone_no_id);
    }
  }, [whatsappNumbers]);

  return (
    <>
      <NoIndex />
      <ToastContainer />
      <div
        className="w-full min-h-0 overflow-x-hidden overflow-y-auto overscroll-contain montserrat-font-1"
        style={{
          height: "calc(100dvh - 64px)",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <div className="p-4 m-0 montserrat-font-1">
          <p className="text-lg font-semibold pl-4">Create Campaign</p>

          <div className="w-full px-0 montserrat-font-1">
            <div className=" p-5 m-2">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* LEFT FORM */}
                <div className="lg:col-span-2 space-y-6">
                  <div className="col-md-12">
                    <div className="bg-white border rounded-md p-6">
                      <h2 className="text-xl font-semibold mb-1">
                        Campaign Name
                      </h2>

                      <p className="text-sm text-gray-500 italic mb-4 mt-2 montserrat-font-2">
                        Choose a descriptive name that reflects your target
                        audience and campaign goals.
                      </p>

                      <div className="w-full md:w-1/2 mb-4">
                        <input
                          type="text"
                          className="w-full border rounded-md px-3 py-2 text-sm"
                          placeholder="Enter campaign name"
                          value={campaignName}
                          onChange={(e) => {
                            setcampaignName(e.target.value);
                            setErrorName("");
                          }}
                        />
                      </div>

                      <div className="w-full md:w-1/2">
                        <label className="text-sm font-medium mb-1 block">
                          Campaigning Number
                        </label>

                        <select
                          value={
                            SingleWhatsApp || whatsappNumbers?.[0]?.phone_no_id
                          }
                          onChange={(e) => setSingleWhatsApp(e.target.value)}
                          className="w-full border rounded-md px-3 py-2 text-sm"
                        >
                          {whatsappNumbers?.map((num) => (
                            <option
                              key={num.phone_no_id}
                              value={num.phone_no_id}
                            >
                              {num.phone_no_id} ({num.phone_no})
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <label
                        className="form-check-label"
                        htmlFor="defaultCheck1"
                        style={{ textAlign: "left" }}
                      >
                        <div className="bg-white border rounded-md p-6 mt-4">
                          <h2 className="text-xl font-semibold mb-1">
                            Type of Campaign
                          </h2>

                          <p className="text-sm text-gray-500 italic mb-4 mt-2 montserrat-font-2">
                            Instant campaigns send messages immediately, while
                            scheduled campaigns deliver them at a set time.
                          </p>

                          <label className="text-sm font-medium mb-2 block">
                            Campaign Type
                          </label>

                          <div className="flex gap-6">
                            <label className="flex items-center gap-2 text-sm">
                              <input
                                type="radio"
                                name="campaignType"
                                value="instant"
                                checked={campaignType === "instant"}
                                onChange={() => setCampaignType("instant")}
                              />
                              Instant Campaign
                            </label>

                            <label className="flex items-center gap-2 text-sm">
                              <input
                                type="radio"
                                name="campaignType"
                                value="schedule"
                                checked={campaignType === "schedule"}
                                onChange={() => setCampaignType("schedule")}
                              />
                              Schedule It
                            </label>
                          </div>
                        </div>
                      </label>
                    </div>

                    {/* Schedule Campaign Section */}
                    {campaignType === "schedule" && (
                      <div className="bg-white border rounded-md p-6 mt-4">
                        <h2 className="text-xl font-semibold mb-1">
                          Schedule Date and Time
                        </h2>

                        <p className="text-sm text-gray-700 italic mb-4 montserrat-font-2">
                          Set the start date and time for your campaign.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="text-sm font-medium block mb-1">
                              Start Date
                            </label>

                            <input
                              type="date"
                              className="w-full border rounded-md px-3 py-2 text-sm"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>

                          <div>
                            <label className="text-sm font-medium block mb-1">
                              Start Time
                            </label>

                            <input
                              type="time"
                              className="w-full border rounded-md px-3 py-2 text-sm"
                              value={startTime}
                              onChange={(e) => setStartTime(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="bg-white border rounded-md p-3 mt-2 montserrat-font-1">
                    <div className="flex justify-between w-full montserrat-font-1">
                      <div className="w-full md:w-2/3 px-4">
                        <div>
                          <p className="text-base font-semibold">
                            Select template
                            <p className="mb-2 mt-2">
                              <span className="text-sm text-gray-500 italic">
                                Select the pre-approved template.
                              </span>
                            </p>
                          </p>

                          <div className="mb-5 relative">
                            <div
                              onClick={() => setShowDropdown(!showDropdown)}
                              className="w-full border rounded-md px-3 py-2 text-sm cursor-pointer bg-white"
                            >
                              {selectedTemplate?.name || "Select a template"}
                            </div>

                            {showDropdown && (
                              <div className="absolute z-20 w-full mt-1 border rounded-md bg-white shadow-md max-h-[240px] overflow-y-auto">
                                {templates
                                  .filter(
                                    (t) =>
                                      t.status?.toUpperCase() === "APPROVED",
                                  )
                                  .map((template, index) => (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        handleTemplateSelect({
                                          target: { value: template.name },
                                        });
                                        setShowDropdown(false);
                                      }}
                                      className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                                    >
                                      {template.name}
                                    </div>
                                  ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div>
                          {selectedTemplate && selectedTemplate.components && (
                            <div>
                              {selectedTemplate.components.map(
                                (component, idx) => (
                                  <div
                                    className="bg-white border p-4 my-4 rounded-md"
                                    key={idx}
                                  >
                                    <div className="font-semibold mb-2">
                                      {component.type}
                                    </div>

                                    {!component.buttons &&
                                      component.format !== "IMAGE" &&
                                      component.format !== "VIDEO" && (
                                        <p>
                                          <strong>Text:</strong>{" "}
                                          {component.text}
                                        </p>
                                      )}

                                    {/* IMAGE */}
                                    {component.format === "IMAGE" && (
                                      <div>
                                        <label
                                          htmlFor={`image-upload-${idx}`}
                                          className="block text-sm mb-2"
                                        >
                                          Upload image in header
                                        </label>

                                        <input
                                          type="file"
                                          id={`image-upload-${idx}`}
                                          className="pt-2"
                                          accept="image/*"
                                          onChange={handleImageUpload}
                                        />

                                        {imageFile.length > 0 && (
                                          <div className="flex justify-center p-2 pt-4">
                                            <img
                                              src={URL.createObjectURL(
                                                imageFile[0],
                                              )}
                                              alt="Uploaded"
                                              className="max-w-[90%]"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {/* VIDEO */}
                                    {component.format === "VIDEO" && (
                                      <div>
                                        <label
                                          htmlFor={`video-upload-${idx}`}
                                          className="block text-sm mb-2"
                                        >
                                          Upload video in header
                                        </label>

                                        <input
                                          type="file"
                                          id={`video-upload-${idx}`}
                                          className="pt-2"
                                          accept="video/*"
                                          onChange={handleVideoUpload}
                                        />

                                        {mediaUploadLoading ? (
                                          <div className="flex justify-center my-4">
                                            <div className="loader"></div>
                                          </div>
                                        ) : videoUrl ? (
                                          <div className="flex justify-center p-2 pt-4">
                                            <video
                                              src={videoUrl}
                                              controls
                                              className="max-w-[90%]"
                                            />
                                          </div>
                                        ) : null}
                                      </div>
                                    )}

                                    {/* DOCUMENT */}
                                    {component.format === "DOCUMENT" && (
                                      <div>
                                        <label
                                          htmlFor={`document-upload-${idx}`}
                                          className="block text-sm mb-2"
                                        >
                                          Upload document in header
                                        </label>

                                        <input
                                          type="file"
                                          id="document-upload"
                                          className="pt-2"
                                          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                          onChange={handleDocumentUpload}
                                        />

                                        {mediaUploadLoading &&
                                          templateFormat === "DOCUMENT" && (
                                            <div className="text-sm text-blue-600 mt-2">
                                              Uploading document...
                                            </div>
                                          )}

                                        {documentPreviewUrl && (
                                          <div className="flex justify-center p-2 pt-4">
                                            {documentFile.type ===
                                            "application/pdf" ? (
                                              <iframe
                                                src={documentPreviewUrl}
                                                className="w-full h-[500px] border-none"
                                              />
                                            ) : (
                                              <p>
                                                Uploaded File:{" "}
                                                <a
                                                  href={documentPreviewUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-600 underline"
                                                >
                                                  View Document
                                                </a>
                                              </p>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {/* BUTTONS */}
                                    {component.buttons &&
                                      component.buttons.length > 0 && (
                                        <div>
                                          {component.buttons.map(
                                            (button, bIdx) => (
                                              <p key={bIdx}>
                                                Button {bIdx + 1}.{" "}
                                                <span className="text-sm font-medium">
                                                  {button.text}
                                                </span>
                                              </p>
                                            ),
                                          )}
                                        </div>
                                      )}
                                  </div>
                                ),
                              )}
                            </div>
                          )}

                          {/* EXCEL UPLOAD */}

                          {selectedTemplate && (
                            <>
                              <div>
                                <input
                                  type="file"
                                  className="w-full border rounded-md px-3 py-2"
                                  onChange={handleFileUpload}
                                  accept=".xlsx"
                                />
                              </div>

                              {isProcessing && (
                                <LoadingScreen text="Checking and uploading file..." />
                              )}

                              <p className="text-red-500 mt-2">
                                <b>*Ensure Country Code On Mobile Number</b>
                              </p>

                              <p
                                className="text-blue-600 mt-2 underline cursor-pointer"
                                onClick={() =>
                                  downloadSampleExcel(selectedTemplate)
                                }
                              >
                                Download {selectedTemplate.name} Sample Excel
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 pt-5 flex items-center m-0">
                    <button
                      id="launch"
                      onClick={CreateNewCampaign}
                      className="ml-3 w-[150px] bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md"
                    >
                      Save
                    </button>
                  </div>
                </div>

                {/* MOBILE PREVIEW */}
                <div className="hidden lg:flex justify-center items-start montserrat-font-1">
                  {selectedTemplate && (
                    <div className="sticky top-20 montserrat-font-1">
                      <div className="mobile-card">
                        <div className="mobile-btn1"></div>
                        <div className="mobile-btn2"></div>
                        <div className="mobile-btn3"></div>
                        <div className="mobile-btn4"></div>

                        <div className="mobile-card-int montserrat-font-1">
                          <div className="bubble-container">
                            <div
                              className={`message-bubble ${animate ? "message-bubble-animate" : ""}`}
                            >
                              {/* IMAGE */}
                              {templateFormat === "IMAGE" &&
                                (imageFile.length > 0 ? (
                                  <img
                                    src={URL.createObjectURL(imageFile[0])}
                                    className="max-w-[90%]"
                                  />
                                ) : (
                                  <div className="border rounded-lg w-[200px] h-[120px] flex items-center justify-center text-gray-400 text-sm">
                                    Image Header
                                  </div>
                                ))}

                              {/* VIDEO */}
                              {templateFormat === "VIDEO" &&
                                (videoUrl ? (
                                  <video
                                    src={videoUrl}
                                    controls
                                    className="max-w-[90%]"
                                  />
                                ) : (
                                  <div className="border rounded-lg w-[200px] h-[120px] flex items-center justify-center text-gray-400 text-sm">
                                    Video Header
                                  </div>
                                ))}

                              {/* DOCUMENT */}
                              {templateFormat === "DOCUMENT" && (
                                <div className="border rounded-lg w-[200px] h-[120px] flex items-center justify-center text-gray-400 text-sm">
                                  Document Header
                                </div>
                              )}

                              {headerText && (
                                <div className="header-text">{headerText}</div>
                              )}

                              {bodyText && (
                                <div className="body-text py-1">{bodyText}</div>
                              )}

                              {footerText && (
                                <div className="footer-text">{footerText}</div>
                              )}

                              <div className="footer-text text-right">
                                {new Date().toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </div>
                            </div>

                            {buttonText.length > 0 &&
                              buttonText.map((text, index) => (
                                <div
                                  key={index}
                                  className={`button-bubble ${animate ? "button-bubble-animate" : ""}`}
                                >
                                  <div className="button-text text-green-600 text-center mb-1">
                                    {text}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>

                        <div className="mobile-top">
                          <div className="mobile-camera">
                            <div className="mobile-int"></div>
                          </div>
                          <div className="mobile-speaker"></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewCampaign;